import React from 'react';
import ProgressSpinnerSmall from 'APP_ROOT/components/common/ProgressSpinnerSmall';
import PropTypes from 'prop-types';

export default class EditableLabel extends React.PureComponent {
    render() {
        const {
            value,
            editing,
            loading,
            onRequestEdit,
            onChange,
            onCancel,
            maxLength,
            canEdit = true
        } = this.props;

        return editing ? (
                <EditText
                    initialValue={value}
                    onCommit={onChange}
                    onCancel={onCancel}
                    maxLength={maxLength || 16}
                />
            ) : (
                <Label
                    value={value}
                    loading={loading}
                    startEditing={onRequestEdit}
                    canEdit={canEdit}
                />
            );
    }
}

EditableLabel.propTypes = {
    value: PropTypes.string,
    editing: PropTypes.bool,
    loading: PropTypes.bool,
    maxLength: PropTypes.number,
    onRequestEdit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
}

// <i className="material-icons">edit</i>;
const Label = ({ value, loading, canEdit, startEditing }) => (
    <div className="edit-label">
        <span>{value}</span>
        {
            loading &&
                <div className={"status-overlay"}>
                    <ProgressSpinnerSmall />
                </div>
        }
        {
            !loading && canEdit &&
                <button onClick={startEditing}>
                    <i className="material-icons">edit</i>
                </button>
        }
    </div>
);

class EditText extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            value: props.initialValue
        }
        this.inputRef = React.createRef();
    }

    componentDidMount() {
        this.inputRef.current.select();
		document.addEventListener("keydown", this.escFunction, false);
    }

	componentWillUnmount(){
		document.removeEventListener("keydown", this.escFunction, false);
	}

	escFunction = (event) => {
		if(event.keyCode === 27) {
			this.props.onCancel();
		}
	}

    handleChange = (e) => {
        const { maxLength } = this.props;
        let value = e.target.value;
        if (value.length > maxLength) {
            value = value.substring(0, maxLength);
        }
        this.setState({
            value
        });
    }

    handleCommit = (e) => {
        e.preventDefault();
        if(!this.state.value) {
            return;
        }
        this.props.onCommit(this.state.value);
    }

    render () {
        return (
            <div className="edit-text">
                <form onSubmit={this.handleCommit}>
                    <input
                        ref={this.inputRef}
                        onChange={this.handleChange}
                        value={this.state.value}
                        size={this.props.maxLength > 16 ? 16 : this.props.maxLength}
                    />
                    <button type="submit">
                        <i className="material-icons">check</i>
                    </button>
                    <button onClick={this.props.onCancel}>
                        <i className="material-icons">close</i>
                    </button>
                </form>
            </div>
        );
    }
}
